// extracted by mini-css-extract-plugin
export default {"root":"VolumeControls_root__Ek0W9","mute-toggle":"VolumeControls_mute-toggle__TpW4N","padding":"VolumeControls_padding__SYuS9","container":"VolumeControls_container__Sh2kd"};